"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Info = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(image_1.default, { src: "/img/icons/casino-outline.svg", width: 20, height: 20, alt: "icon games" }),
            react_1.default.createElement("span", null, t('mainBannerInfoGames'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(image_1.default, { src: "/img/icons/timer.svg", width: 20, height: 20, alt: "icon games" }),
            react_1.default.createElement("span", null, t('mainBannerInfoSupport'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.item },
            react_1.default.createElement(image_1.default, { src: "/img/icons/support-agent-rounded.svg", width: 20, height: 20, alt: "icon games" }),
            react_1.default.createElement("span", null, t('mainBannerInfoPayment')))));
};
exports.default = Info;
